<script>
import { mapState, mapActions } from "vuex";
import SendSvg from "@/assets/img/icon/SendSvg.vue";
import IconNoticias from "@/assets/img/icon/section/IconNoticias.vue";

export default {
  components: {
    SendSvg,
    IconNoticias,
  },
  data() {
    return {
      comentarios: [],
      texto_comentario: "",
      texto_respuesta: "",
      texto_editando: "",
      id_usuario_actual: this.$ls.get("user").id_usuario,
      show_spinner: false,
      accion_editar: false,
      id_modulo: "3",
    };
  },
  computed: {
    ...mapState("NoticiasModules", ["noticia"]),
  },
  methods: {
    ...mapActions("NoticiasModules", [
      "getUnaNoticia",
      "crearComentariosEmpresaNoticia",
      "editarComentarioEmpresaNoticia",
      "editarComentarioDelComentarioEmpresaNoticia",
      "eliminarComentarioEmpresaNoticia",
      "eliminarComentarioDelComentario",
      "addLikeNoticia",
      "delLikeNoticia",
      "addLikeComentarioEmpresa",
      "delLikeComentarioEmpresa",
    ]),
    ...mapActions("VistosModule", ["insertVisto"]),
    async insertVistos() {
      if (this.$route.params.id_noticia === undefined) return;
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_modulo: this.id_modulo,
        id_objeto: this.$route.params.id_noticia,
      };
      await this.insertVisto(data_);
    },
    toDatePuntos(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);
      return newDate
        .toLocaleString("es-CL", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
        .replace(/-/g, ".");
    },
    horaLegible(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);
      return newDate.toLocaleString("es-CL", {
        hour: "numeric",
        minute: "numeric",
      });
    },
    async toggleLikeNoticia(noticia, liked) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: noticia,
        id_subobjeto: "0",
        id_modulo: "3",
      };
      if (liked === null) {
        await this.addLikeNoticia(data_);
      } else {
        await this.delLikeNoticia(data_);
      }
    },

    async handleSubmitComentario(comentario_padre = "") {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: this.$route.params.id_noticia,
        id_modulo: this.id_modulo,
        texto:
          comentario_padre == "" ? this.texto_comentario : this.texto_respuesta,
        id_comentario: comentario_padre,
        menciones: "",
      };
      console.log(data_);
      await this.crearComentariosEmpresaNoticia(data_);
      this.texto_comentario = "";
      this.texto_respuesta = "";
    },

    async eliminarComentario(id_comentario, id_respuestas) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: this.$route.params.id_noticia,
        id_modulo: this.id_modulo,
        id_comentario: id_respuestas == false ? id_comentario : id_respuestas,
      };
      console.log("datos para eliminar: ", data_);
      if (id_respuestas == false) {
        console.log("comentario eliminar");
        await this.eliminarComentarioEmpresaNoticia(data_);
      } else {
        console.log("comentario del comentario eliminar ");
        await this.eliminarComentarioDelComentario(data_);
      }
    },
    async toggleLikeComentario(id_comentario, liked) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: this.$route.params.id_noticia,
        id_modulo: this.id_modulo,
        id_comentario: id_comentario,
        id_like: "",
      };
      if (!liked) {
        await this.addLikeComentarioEmpresa(data_);
      } else {
        await this.delLikeComentarioEmpresa(data_);
      }
      this.$forceUpdate();
    },
    toggleEditingComentario(comentario) {
      this.accion_editar = !this.accion_editar;
      let texto_ed = "";
      comentario.is_edit = !comentario.is_edit;
      texto_ed = comentario.texto;
      this.texto_editando = texto_ed;
      this.$forceUpdate();
    },
    toggleEditingRespuesta(id_comentario, id_respuesta) {
      this.accion_editar = !this.accion_editar;
      let texto_ed = "";
      console.log(
        "editando comentario del comentario: ",
        texto_ed,
        " id_comentario ",
        id_comentario,
        " respuesta",
        id_respuesta
      );
      this.noticia.comentarios.forEach(function (comentarios) {
        comentarios.respuestas_comentarios.forEach(function (respuestas) {
          if (respuestas.id_comentario == id_respuesta) {
            respuestas.is_edit = !respuestas.is_edit;
            texto_ed = respuestas.texto;
          }
        });
      });
      this.texto_editando = texto_ed;
      this.$forceUpdate();
    },
    async editarComentario(comentario, id_respuestas) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: this.$route.params.id_noticia,
        id_modulo: this.id_modulo,
        texto: this.texto_editando,
        id_comentario:
          id_respuestas == false ? comentario.id_comentario : id_respuestas,
        menciones: "",
      };
      //console.log("data editar: ", data_);
      if (id_respuestas == false) {
        console.log("comentario ");
        await this.editarComentarioEmpresaNoticia(data_);
      } else {
        console.log("comentario del comentario");
      }
      comentario.is_edit = false;
      this.texto_editando = "";
    },
    async getNoticiaSingle() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_noticia: this.$route.params.id_noticia,
      };
      await this.getUnaNoticia(data_);
    },
    textareaComentario() {
      let textarea = document.querySelector("#textarea-comentario");
      if (this.texto_comentario === "") {
        textarea.style.height = "63px";
        return;
      }
      textarea.style.height = "1px";
      textarea.style.height = 25 + textarea.scrollHeight + "px";
    },
  },
  async created() {
    this.getNoticiaSingle();
    this.insertVistos()
  },
};
</script>

<template>
  <section id="noticia">
    <div class="row">
      <div class="col-12">
        <h1
          class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center"
        >
          <IconNoticias class="me-2 icon-svg-45" />
          Noticias
        </h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home" class="color-main">
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/noticias" class="color-main">
                <font-awesome-icon
                  icon="fa-solid fa-newspaper"
                ></font-awesome-icon>
                Noticias
              </router-link>
            </li>
            <li class="breadcrumb-item active">
              {{ noticia.titulo_noticia }}
            </li>
          </ol>
        </nav>

        <div class="row">
          <div class="col-12">
            <p class="text-secondary h5-custom mb-0">
              ¡Entérate de todas nuestras novedades! Filtra las noticias
              seleccionando una categoría.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="border-bottom mb-3 pb-3"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-7 mb-3">
        <div class="card border-0">
          <div class="card-body">
            <img :src="noticia.url_imagen_principal" class="rounded w-100" />
            <div class="row mt-2">
              <div class="col-12">
                <h4 class="font-main font-700 color-main">
                  {{ noticia.titulo_noticia }}
                </h4>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-secondary text-opacity-50">
                  {{ toDatePuntos(noticia.fecha_noticia) }}
                </span>
                <div>
                  <a
                    href="javascript:"
                    @click.prevent="
                      toggleLikeNoticia(
                        noticia.id_noticia,
                        noticia.confirm_like
                      )
                    "
                    class="card-custom-footer-like color-main"
                  >
                    <span
                      v-if="noticia.confirm_like === null"
                      key="solid-heart"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-heart"
                      ></font-awesome-icon>
                    </span>
                    <span
                      v-if="noticia.confirm_like !== null"
                      key="regular-heart"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-heart"
                        class="color-red"
                      ></font-awesome-icon>
                    </span>
                  </a>
                  <span class="card-custom-footer-like-count ms-1">
                    {{ noticia?.likes?.length }}
                  </span>
                </div>
              </div>

              <template v-for="cont in noticia.contenido">
                <div
                  v-if="cont.tipo_contenido[0].id_tipo_contenido === '1'"
                  :key="'v-if' + cont.id_contenido"
                  class="row"
                >
                  <div class="col-12 mt-2">
                    <div v-html="cont.texto" class="noticia-contenido"></div>
                  </div>
                </div>
                <div
                  v-else-if="cont.tipo_contenido[0].id_tipo_contenido === '2'"
                  :key="'v-else-if' + cont.id_contenido"
                  class="row d-flex justify-content-center"
                >
                  <div class="col-12 col-lg-7">
                    <img
                      :src="cont.url_imagen"
                      class="noticia-img rounded-4"
                      :alt="noticia.titulo_noticia"
                    />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-5 mb-3">
        <div class="card border-0 mb-3">
          <div class="card-body">
            <form @submit.prevent="handleSubmitComentario('')">
              <textarea
                @keyup="textareaComentario()"
                id="textarea-comentario"
                class="textarea-auto"
                placeholder="Escribe un comentario ..."
                rows="3"
                v-model="texto_comentario"
                maxlength="255"
              ></textarea>
              <div class="row">
                <div class="col-12 d-flex justify-content-between">
                  <div class="form-text text-end text-secondary">
                    {{ texto_comentario.length }} / 255 caracteres
                  </div>
                  <button
                    type="submit"
                    class="btn btn-link transition-all p-0 color-main"
                  >
                    <SendSvg />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div
          v-for="comentario in noticia.comentarios"
          :key="comentario.id_comentario"
          class="card border-0 mb-3"
        >
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-shrink-0 avatar-user">
                <img
                  width="50"
                  v-if="
                    comentario.usuario[0].imagen_perfil ||
                    /.jpg|.jpeg|.png/.test(comentario.usuario[0].imagen_perfil)
                  "
                  :src="comentario.usuario[0].imagen_perfil"
                  class="img-object-cover rounded-circle me-3"
                  alt="Imagen de usuario"
                />
                <img
                  v-else
                  width="50"
                  src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                  class="img-object-cover rounded-circle me-3"
                  alt="Imagen de usuario"
                />
                <span class="avatar-user-online"></span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex mb-3">
                  <div class="flex-grow-1">
                    <h5 class="font-700 h5-custom text-secondary mb-0">
                      {{
                        capitalizeFirstLetter(
                          comentario.usuario[0].primer_nombre
                        )
                      }}
                      {{
                        capitalizeFirstLetter(
                          comentario.usuario[0].apellido_paterno
                        )
                      }}
                    </h5>
                    <span class="text-secondary text-opacity-50">
                      <font-awesome-icon
                        icon="fa-solid fa-calendar"
                      ></font-awesome-icon>
                      {{ comentario.fecha_creacion.split("T")[0] }}
                      <font-awesome-icon
                        icon="fa-solid fa-clock"
                      ></font-awesome-icon>
                      {{
                        comentario.fecha_creacion.split("T")[1].split(".")[0]
                      }}
                    </span>
                  </div>
                  <div class="flex-shrink-0 d-flex align-items-start">
                    <button
                      v-if="
                        comentario.usuario[0].id_usuario === id_usuario_actual
                      "
                      @click="toggleEditingComentario(comentario)"
                      class="btn btn-sm btn-custom-line btn-custom-line-gray border-0"
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      data-bs-custom-class="tooltip-custom tooltip-custom-main"
                      data-bs-title="Nueva auditoría"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-pen"
                      ></font-awesome-icon>
                    </button>
                    <button
                      v-if="
                        comentario.usuario[0].id_usuario === id_usuario_actual
                      "
                      @click="
                        eliminarComentario(comentario.id_comentario, false)
                      "
                      class="btn btn-sm btn-custom-line btn-custom-line-gray ms-2 border-0"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-trash"
                      ></font-awesome-icon>
                    </button>
                  </div>
                </div>
                <p class="text-secondary text-opacity-75">
                  <template v-if="!comentario.is_edit">
                    {{ comentario.texto }}
                  </template>
                  <template v-if="comentario.is_edit">
                    <textarea
                      class="textarea-auto textarea-120"
                      rows="3"
                      v-model="texto_editando"
                      maxlength="255"
                    ></textarea>
                    <div class="d-flex justify-content-between">
                      <div>
                        <button
                          class="btn btn-sm btn-custom-line-main"
                          @click="editarComentario(comentario, false)"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-floppy-disk"
                          ></font-awesome-icon>
                          Guardar
                        </button>
                        <button
                          class="btn btn-sm btn-custom-line-dark ms-2"
                          @click="toggleEditingComentario(comentario)"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-xmark"
                          ></font-awesome-icon>
                          Cancelar
                        </button>
                      </div>
                      <div class="form-text text-end text-secondary">
                        {{ texto_editando.length }} / 255
                      </div>
                    </div>
                  </template>
                </p>
                <div class="flex-shrink-0 d-flex justify-content-end">
                  <a
                    href="javascript:"
                    @click="
                      toggleLikeComentario(
                        comentario.id_comentario,
                        comentario.likes.some(
                          (like) =>
                            like.usuario[0].id_usuario == id_usuario_actual
                        )
                      )
                    "
                    class="card-custom-footer-like color-main"
                  >
                    <span
                      v-if="
                        comentario?.likes?.length > 0 &&
                        comentario?.likes?.filter(
                          (x) => x.usuario[0].id_usuario == id_usuario_actual
                        ).length > 0
                      "
                      key="regular-heart"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-heart"
                        class="color-red"
                      ></font-awesome-icon>
                    </span>
                    <span v-else key="solid-heart">
                      <font-awesome-icon
                        icon="fa-solid fa-heart"
                      ></font-awesome-icon>
                    </span>
                    <span class="card-custom-footer-like-count">
                      {{ comentario?.likes?.length }}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
